import { computed, makeObservable } from "mobx";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelKind, type SyncUpdateValue } from "@/store/sync/types";
import type { WithAppStore } from "@/store/types";
import type { SpaceAccountConnectionModelData } from "@/store/connections/types";

export class SpaceAccountConnectionObservable extends BaseSyncModel<SpaceAccountConnectionModelData> {
  public modelKind = SyncModelKind.SpaceAccountConnection;

  constructor({
    id,
    data,
    store,
  }: {
    id: string;
    data: SyncUpdateValue<SpaceAccountConnectionModelData>;
  } & WithAppStore) {
    super({ id, data, store });
    makeObservable(this, {
      modelKind: false,
      associatedSpaceAccountId: computed,
      serverUrl: computed,
      resourceUrl: computed,
      serverName: computed,
      status: computed,
      authMethod: computed,
      accessMode: computed,
      toolCount: computed,
      errorKind: computed,
      errorMessage: computed,
      lastRefreshedAt: computed,
      lastScanStartedAt: computed,
      lastScanCompletedAt: computed,
      provider: computed,
      providerAppId: computed,
      authorizationHealth: computed,
      authorizationExpiresAt: computed,
    });
  }

  get associatedSpaceAccountId() {
    return this.modelData.associated_space_account_id;
  }
  get serverUrl() {
    return this.modelData.server_url;
  }
  get resourceUrl() {
    return this.modelData.resource_url;
  }
  get serverName() {
    return this.modelData.server_name;
  }
  get status() {
    return this.modelData.status;
  }
  get authMethod() {
    return this.modelData.auth_method;
  }
  get accessMode() {
    return this.modelData.access_mode;
  }
  get toolCount() {
    return this.modelData.tool_count;
  }
  get errorKind() {
    return this.modelData.error_kind;
  }
  get errorMessage() {
    return this.modelData.error_message;
  }
  get lastRefreshedAt() {
    return this.modelData.last_refreshed_at;
  }
  get lastScanStartedAt() {
    return this.modelData.last_scan_started_at;
  }
  get lastScanCompletedAt() {
    return this.modelData.last_scan_completed_at;
  }
  get provider() {
    return this.modelData.provider;
  }
  get providerAppId() {
    return this.modelData.provider_app_id;
  }
  get authorizationHealth() {
    return this.modelData.authorization_health;
  }
  get authorizationExpiresAt() {
    return this.modelData.authorization_expires_at;
  }
}
